






import { Component, Vue } from "vue-property-decorator";
import AuditFasilitasApdList from "@/components/ppi/audit-fasilitas-apd/AuditFasilitasApdList.vue";

@Component({
  components: { AuditFasilitasApdList }
})
export default class AuditFasilitasApdPage extends Vue {}
